import * as Yup from "yup"

export const updateBrandSchema = Yup.object().shape({
  brandid: Yup.string().required("This value is required"),
  type: Yup.string().required("This value is required"),
  WholesalePrice: Yup.string(),
  TradePrice: Yup.string(),
  RecommendedRetailPrice: Yup.string(),
})
